import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Box } from '@mui/material';
import RnDDialog from '../RnDDialog/RnDDialog';
import { useIntl } from 'react-intl';

const ConfirmAddToPlaylist = ({ isOpen, onClose, onConfirmAddtoPlaylist, confirmDialogData }) => {
	const intl = useIntl();

	return (
		<RnDDialog
			open={isOpen}
			size="sm"
			title={intl.formatMessage({
				id: 'pages.MediaFiles.components.BulkAddToScreens.ConfirmDialogTitle',
			})}
			heightSize="xs"
			onClose={onClose}
			onActions={['Confirm'].map((item, index) => {
				return (
					<Button key={index} onClick={onConfirmAddtoPlaylist} variant="contained" color="primary">
						{item}
					</Button>
				);
			})}
		>
			<Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
				{/* Preview container */}
				<Box flex={1} display="flex" justifyContent="center" p={2}>
					{confirmDialogData.previewUrl ? (
						<Box
							component="img"
							src={confirmDialogData.previewUrl}
							alt="Preview"
							sx={{
								maxHeight: 120,
								width: 'auto',
								maxWidth: '100%',
								objectFit: 'contain',
							}}
						/>
					) : (
						<span>No Preview Available</span>
					)}
				</Box>
				{/* Info container */}
				<Box flex={2}>
					<Box flex={2}>
						<Typography variant="h6">
							{intl.formatMessage({
								id: 'pages.MediaFiles.components.BulkAddToScreens.ConfirmDialogMessage1',
							})}
							<b>{confirmDialogData.count}</b>{' '}
							{intl.formatMessage({
								id: 'pages.MediaFiles.components.BulkAddToScreens.ConfirmDialogMessage2',
							})}
							.
						</Typography>
						{confirmDialogData.extra && (
							<Typography variant="h6">{confirmDialogData.extra}</Typography>
						)}
					</Box>
				</Box>
			</Box>
		</RnDDialog>
	);
};

ConfirmAddToPlaylist.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirmAddtoPlaylist: PropTypes.func,
	confirmDialogData: PropTypes.object.isRequired,
};

export default ConfirmAddToPlaylist;
